import * as React from 'react';
const SvgEye = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#AFB5BA"
      d="M8 6.595a2.962 2.962 0 1 1 0 5.923 2.962 2.962 0 0 1 0-5.923m0 1.11a1.851 1.851 0 1 0 0 3.703 1.851 1.851 0 0 0 0-3.703M8 4a7.41 7.41 0 0 1 7.183 5.6.555.555 0 1 1-1.077.27 6.296 6.296 0 0 0-12.212.004.555.555 0 0 1-1.077-.27A7.41 7.41 0 0 1 8 4"
    />
  </svg>
);
export default SvgEye;
